// TODO: initial values, make sure they're aligned between editors
export enum InvoiceEditorVersion {
  Ageras = 'ageras',
  Zervant = 'zervant',
  Mobile = 'mobile',
}
